import { CircularProgress, Modal } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import { INFINITE_LOADING_ATTR } from "../../hooks/useInfiniteScroll";

const Spinner = () => {
  if (
    typeof document !== "undefined" &&
    document.body.hasAttribute(INFINITE_LOADING_ATTR)
  ) {
    return null;
  }
  return (
    <Modal open={true} disableAutoFocus disableEnforceFocus disableRestoreFocus>
      <Box className="a-center border-0 ring-0 outline-0  rounded-2xl">
        <CircularProgress />
      </Box>
    </Modal>
  );
};

export default Spinner;
